import capitalize from "lodash/capitalize";

import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../helpers/generateAutomationName";
import { SharedIcon } from "../ActivationSetDropdown/components/ActivationItem/styles";
import { ACTIVATION_SHARED_TOOLTIP } from "../Header/texts";

import * as SC from "./styles";

interface IActivionSetItem {
    id: string;
    text: string;
    allDomains: string[];
    sharedBy: string;
    onClick?: () => void;
}

export const ActivionSetItem = ({ id, text, allDomains, sharedBy, onClick }: IActivionSetItem) => {
    return (
        <SC.ActivionSetItemContainer
            id={id}
            onClick={onClick}
        >
            <SC.ActivionSetItemContent>
                <SC.PrimaryDomain>{capitalize(text)}</SC.PrimaryDomain>
                <SC.Count>({allDomains.length})</SC.Count>
                {sharedBy ? (
                    <PlainTooltip tooltipContent={translate(ACTIVATION_SHARED_TOOLTIP, { name: sharedBy })}>
                        <div
                            data-automation={generateAutomationName("home", [
                                "header",
                                "activation",
                                "dropdown",
                                "item",
                                "sharedBy",
                            ])}
                        >
                            <SharedIcon
                                iconName="social-share"
                                size="xs"
                                iconColor={colorsPalettes.carbon[300]}
                            />
                        </div>
                    </PlainTooltip>
                ) : null}
            </SC.ActivionSetItemContent>
        </SC.ActivionSetItemContainer>
    );
};
